module.exports = __webpack_public_path__ + "static/media/logosissara.666aae6b.png";